module.exports = __webpack_public_path__ + "static/media/Poppins-Light-300.7e3a130b.ttf";